module.exports = __webpack_public_path__ + "static/EnChartMobile-02619746f9315e2e20032dc9c29c0b7e.svg";